<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="分类名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
            </el-form-item>
            <el-form-item v-if="showParent" label="上级分类" prop="parent_cuuid">
                <VideoCategory parent v-model="form.parent_cuuid" style="width: 100%"></VideoCategory>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="handleConfirm">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { add, edit, detail } from "@/api/video/category";
import VideoCategory from "@/components/VideoCategory";
export default {
    components: { VideoCategory },
    data() {
        return {
            visible: false,
            title: "新增分类",
            form: {
                name: "",
            },
            rules: {
                name: [{ required: true, message: "请输入分类名称" }],
            },
            showParent: false,
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            this.showParent = false;
            if (row) {
                if (row.act === "add") {
                    this.title = "新增二级分类";
                    this.form.name = "";
                    this.form.parent_cuuid = row.uuid;
                    this.showParent = true;
                } else {
                    this.title = "编辑分类";
                    this.form.name = row.name;
                    this.form.uuid = row.uuid;
                    if (row.fid != "0") {
                        this.showParent = true;
                        this.form.parent_cuuid = row.fid;
                    }
                }
            } else {
                this.title = "新增分类";
                this.form.name = "";
            }
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        getDetail() {
            detail({ uuid: this.form.uuid }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form.name = result.name;
                        this.form.uuid = result.uuid;
                    } else {
                        this.form.name = "";
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate();
                        });
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                };
                if (this.form.uuid) {
                    edit(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.$emit("update");
                            this.visible = false;
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("新增成功");
                            this.$emit("update");
                            this.visible = false;
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
